// extracted by mini-css-extract-plugin
module.exports = {"Slides":"Slides_Slides__3bMBl","Image":"Slides_Image__2F30k","h3":"Slides_h3__2XoDb"};